import React from 'react';

import { gettext } from '@eb/i18n';

import CheckMark from '../components/CheckMark';

export const TABLE_TITLE_SHORT = gettext('Features');
export const AFTER_DOWNGRADE = gettext('No price change');
export const KEEP_CURRENT = gettext('Keep current package');
export const UPDATE_CTA = gettext('Update to new Essentials');
export const CURRENT_PACKAGE = gettext('Current package');
export const AFTER_UPDATE = gettext('After update');
export const FEATURE_ONE = gettext('Number of ticket types');
export const FEATURE_ONE_V1 = gettext('One');
export const FEATURE_ONE_V2 = gettext('Unlimited') + ' 🎉';
export const FEATURE_TWO = gettext('Ticketing & registration essentials');
export const FEATURE_THREE = gettext('Listing on Eventbrite and partner sites');
export const FEATURE_FOUR = gettext('Ticket sales on Facebook');
export const FEATURE_FIVE = gettext('Email Campaigns');
export const FEATURE_SIX = gettext('Distribution on partner web sites');
export const WARNING = gettext(
    'You will not be able to switch back to your current package',
);
export const DESCRIPTION = gettext(
    "Here's what's different in our new Essentials package",
);
export const HEADING = gettext('Update to our new Essentials package');

export const UPDATE_BANNER_CTA = gettext('Update Now');
export const UPDATE_BANNER_HEADING = gettext(
    'A newer version of the Essentials package is available',
);

export const PACKAGE_UPDATE_HEADING = {
    heading: HEADING,
    description: DESCRIPTION,
};

export const PACKAGE_UPDATE_FEATURES = [
    {
        feature: FEATURE_ONE,
        currentPackage: FEATURE_ONE_V1,
        newPackage: FEATURE_ONE_V2,
    },
    {
        feature: FEATURE_TWO,
        currentPackage: <CheckMark />,
        newPackage: <CheckMark />,
    },
    {
        feature: FEATURE_THREE,
        currentPackage: <CheckMark />,
        newPackage: <CheckMark />,
    },
    {
        feature: FEATURE_FOUR,
        currentPackage: <CheckMark />,
        newPackage: null,
    },
    {
        feature: FEATURE_FIVE,
        currentPackage: <CheckMark />,
        newPackage: null,
    },
    {
        feature: FEATURE_SIX,
        currentPackage: <CheckMark />,
        newPackage: null,
    },
];

export const PACKAGE_UPDATE_BREADCRUMB = {
    path: '#',
    label: gettext('Update Package'),
};
